import { render } from "./AboutClientsComp.vue?vue&type=template&id=6096e4a1&scoped=true"
import script from "./AboutClientsComp.vue?vue&type=script&lang=js"
export * from "./AboutClientsComp.vue?vue&type=script&lang=js"

import "./AboutClientsComp.vue?vue&type=style&index=0&id=6096e4a1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6096e4a1"]])

export default __exports__